import ModalDeleteFilled from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteAdjustmentDeliveryNoteDraftProps extends ModalEditComponentProps { }

const ModalDeleteAdjustmentDeliveryNoteDraft: React.FC<ModalDeleteAdjustmentDeliveryNoteDraftProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/adjustmentDeliveryNote/deleteAdjustmentDeliveryNoteDraft',
        data: {
            id: allRowData?.header?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteDraftAdjustmentDeliveryNote', '¿Seguro que quieres eliminar este borrador de albarán de regularización?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteAdjustmentDeliveryNoteDraft